import Axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineNumber } from "react-icons/ai";
import ContentValidation from "../../components/common/ContentValidation";
import TableFilterBox from "../../components/common/TableFilterBox";
import PaginationComp from "../../components/Dashboard/items/Pagination";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import { Modal } from "antd";
import TextInputModal from "../../components/common/TextInputModal";
import { successToast, unsuccessToast } from "../../helpers/ErrorsToasts";
import { SelectForm } from "../../components/common/Buttons";
import InputText from "../../components/orders/accepted_orders/InputFilter";
import { getSuppliersOption } from "../../redux/Actions/supplierAction";

export default function AdditionalSupplierCodesScreen({ match }) {
  const [pageCount, setPageCount] = useState(100);
  const [page, setPage] = useState(1);
  const [filter_string, setFilterString] = useState("");
  const [filters, setfilters] = useState({
    supplier_id: undefined,
    product_identifier: "",
  });

  useEffect(() => {
    getSuppliersOption().then((res) => {
      if (!res.data?.data) return;
      setSuppliersData(
        res.data.data.map((e) => ({
          value: e.id,
          label: e.title || e.name,
        }))
      );
    });
  }, []);

  useEffect(() => {
    const fetchASC = async () => {
      setLoading(true);
      try {
        const { data } = await Axios.get(
          `/api/v1/additional_suppliers_codes?page=${page}&per_page=${pageCount}${filter_string}`
        );
        if (!data) throw new Error("Err");
        setData(data.data);
        setTotals(data.totals);
        setLoading(false);
      } catch (err) {
        console.log("Error: ", err);
        setLoading(false);
      }
    };
    fetchASC();
  }, [page, pageCount, filter_string]);
  useEffect(() => onFilter(), [filters.supplier_id]);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [suppliersData, setSuppliersData] = useState([]);
  const [totals, setTotals] = useState(0);

  const [modalDetails, setModalDetails] = useState(false);

  const saveSupplierCode = async (variable) => {
    try {
      const { data: resData } = await Axios.put(
        `/api/v1/additional_suppliers_codes/${variable.id}`,
        {
          additional_supplier_code: {
            supplier_code: variable.supplier_code,
          },
        }
      );
      setData(data.map((e) => (e.id == resData.id ? { ...e, ...resData } : e)));
      setModalDetails(false);
      return successToast("ascAlert-s");
    } catch (err) {
      return unsuccessToast("ascAlert-e");
    }
  };

  const onFilter = () => {
    let filterParams = [];

    if (filters.product_reference) {
      filterParams.push(`&q[product_code_cont]=${filters.product_reference}`);
    }
    if (filters.supplier_code) {
      filterParams.push(`&q[supplier_code_cont]=${filters.supplier_code}`);
    }
    if (filters.supplier_id) {
      filterParams.push(`&q[supplier_id_eq]=${filters.supplier_id}`);
    }

    setFilterString(filterParams.join(""));
    setPage(1);
  };
  return (
    <Container
      location={{
        locationName: "Additional supplier codes",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          length={`${totals || 0} / ${data.length || 0}`}
          onChangeCountPage={setPageCount}
          countPage={pageCount}
          text="tiekėjų kodų"
          text2="Tiekėjų kodų"
        />
      </ContentBlock>
      <ContentBlock>
        <TableFilterBox
          clearFilter={() => {
            setfilters({
              supplier_id:
                typeof filters.supplier_id == "undefined" ? null : undefined,
              product_identifier: "",
            });
          }}
        >
          <div className="px-1" style={{ minWidth: "150px" }}>
            <SelectForm
              placeholder="Tiekėjas"
              dropdownMatchSelectWidth={false}
              options={suppliersData}
              value={filters.supplier_id}
              onChange={(e) => {
                setfilters((prev) => ({
                  ...prev,
                  supplier_id: e,
                }));
              }}
            />
          </div>
          <div className="px-1">
            <InputText
              value={filters.product_reference}
              placeholder="Produkto kodas"
              style={{ width: 150, fontSize: "0.75rem" }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  onFilter();
                }
              }}
              onChange={(e) => {
                setfilters({
                  ...filters,
                  product_reference: e.target.value || "",
                });
              }}
            />
          </div>
          <div className="px-1">
            <InputText
              value={filters.supplier_code}
              placeholder="Tiekėjo kodas"
              style={{ width: 150, fontSize: "0.75rem" }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  onFilter();
                }
              }}
              onChange={(e) => {
                setfilters({
                  ...filters,
                  supplier_code: e.target.value || "",
                });
              }}
            />
          </div>
        </TableFilterBox>
        <div>
          <ContentValidation
            loader={loading}
            array={data}
            alertId_s="ascAlert-s"
            alertId_e="ascAlert-e"
          >
            <div className="table-responsive">
              <table className="table table-sm table-hover mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Product</th>
                    <th className="text-black">Product code</th>
                    <th className="text-black">Supplier</th>
                    <th className="text-black">Supplier code</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((e) => {
                    return (
                      <tr className="align-middle tableColumn" key={e.id}>
                        <td className="align-middle" style={{ maxWidth: 400 }}>
                          {e.product?.title}
                        </td>
                        <td className="align-middle">{e.product_code}</td>
                        <td className="align-middle">
                          {e.supplier.title || e.supplier.name}
                        </td>
                        <td className="align-middle">{e.supplier_code}</td>
                        <td className="align-middle">
                          <button
                            className={`btn btn-danger btn-sm`}
                            onClick={() => setModalDetails(e)}
                          >
                            <AiOutlineNumber color="white" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <PaginationComp
                setPagination={setPage}
                page={page}
                totals={totals}
                pageCount={pageCount}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>
      {modalDetails && (
        <ModalPreview
          setIsModalVisible={setModalDetails}
          modalVariables={modalDetails}
          saveSupplierCode={saveSupplierCode}
        />
      )}
    </Container>
  );
}

const ModalPreview = ({
  setIsModalVisible,
  modalVariables,
  saveSupplierCode,
}) => {
  const [code, setCode] = useState(modalVariables.supplier_code);
  return (
    <Modal
      title={`Additional supplier code update`}
      visible={true}
      onOk={() =>
        saveSupplierCode({
          id: modalVariables.id,
          supplier_code: code,
        })
      }
      onCancel={() => setIsModalVisible(false)}
      okText={"Save"}
      cancelText={"Close"}
    >
      <p className="mb-0">
        <b>Supplier:</b>{" "}
        {modalVariables.supplier.title || modalVariables.supplier.title}
      </p>
      <p className="mb-0">
        <b>Product:</b> {modalVariables.product?.title}
      </p>
      <p>
        <b>Product code:</b> {modalVariables.product.identifier}
      </p>
      <TextInputModal
        text="Additional supplier code"
        placeholder="Enter"
        name="supplier_code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />
    </Modal>
  );
};
